import React from "react";
import {IPLData} from "../../components/modules/home/home";

export type PublisherLoginsState = {
    publisherLogins:IPLData[],
    refetchPublisherLogins:()=>void
    isLoadingPL:boolean

}
export const PublisherLoginsContext = React.createContext<PublisherLoginsState>({publisherLogins:null,refetchPublisherLogins:()=>{},isLoadingPL:false})
